require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /usr/src/site-blog/node_modules/core-js/modules/es7.symbol.observable.js
// module id = 426
// module chunks = 99